module.exports = __webpack_public_path__ + "img/stickers-plan-apurement.55195fbb.jpg";